export const ALL_RECENT_ITEMS_COUNT_HOME_REFRESH = 6;

// When the distinct section "Agents waiting for your input" is enabled, the "Pick up where you left off" section is reduced.
export const ALL_RECENT_ITEMS_COUNT_AGENTIC_SESSIONS = 3;
